/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const GeneratedQueryMetadata = core.serialization.object({
    explain: core.serialization.string(),
});
